//@ts-nocheck

import accordion_main from "./components/accordion_main";
import caseAjax from "./components/caseAjax";
import dropSlider from "./components/dropSlider";
import navigation from "./components/navigation";
import provisionsAccordion from "./components/provisionsAccordion";
import quiz from "./components/quiz";
import customInputs from "./components/customInputs";
import emailIdeasForm from "./components/emailIdeasForm";
import video from "./components/video";
import discoverScroll from "./components/discoverScroll";
import sectionSelectAjax from "./components/sectionSelectAjax";
import issueAreaSectionAjax from "./components/issueAreaSectionAjax";

declare global {
  interface Window {
    globals: {
      ajax_url: string;
      home_url: string;
      email_url: string;
    };
    loadingPolyfills: boolean;
    loadedPolyfills: boolean;
  }
}

window.globals = JSON.parse(document.body.dataset.globals);

const init = () => {
  quiz();
  accordion_main();
  dropSlider();
  provisionsAccordion();
  navigation();
  customInputs();
  emailIdeasForm();
  caseAjax();
  video();
  discoverScroll();
  issueAreaSectionAjax();
  sectionSelectAjax();
};

init();
